import React from "react";
import { useLang } from "../context/LangContext";

const IMAGES = [
  { url: "https://images.unsplash.com/photo-1612260715684-6d810c260136?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwyfHxhdHRyYWN0aXZlJTIwbWFuJTIwdW5kZXJ3ZWFyJTIwZGFya3xlbnwwfHx8fDE3ODA5MjQwMTJ8MA&ixlib=rb-4.1.0&q=85", label: "Editorial · Milan", brand: "ARMANI" },
  { url: "https://images.unsplash.com/photo-1549505415-e16dbd446231?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxhdHRyYWN0aXZlJTIwbWFuJTIwdW5kZXJ3ZWFyJTIwZGFya3xlbnwwfHx8fDE3ODA5MjQwMTJ8MA&ixlib=rb-4.1.0&q=85", label: "Print · New York", brand: "CALVIN KLEIN" },
  { url: "https://images.unsplash.com/photo-1573872400090-3870b07085eb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwzfHxhdHRyYWN0aXZlJTIwbWFuJTIwdW5kZXJ3ZWFyJTIwZGFya3xlbnwwfHx8fDE3ODA5MjQwMTJ8MA&ixlib=rb-4.1.0&q=85", label: "Lifestyle · Paris", brand: "HUGO BOSS" },
  { url: "https://images.unsplash.com/photo-1614893228004-447f16ec6398?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxtYWxlJTIwZml0bmVzcyUyMG1vZGVsJTIwYWJzfGVufDB8fHx8MTc4MDkyNDAxMnww&ixlib=rb-4.1.0&q=85", label: "Campaign · Lisbon", brand: "DIESEL" },
];

export default function Inspiration() {
  const { t } = useLang();
  return (
    <section data-testid="inspiration-section" className="py-24 lg:py-32 bg-[#050505]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-16">
          <div className="flex items-center gap-4 mb-6">
            <span className="block w-12 h-px bg-[#00E5FF]" />
            <span className="label-eyebrow text-[#00E5FF]">{t.inspiration.eyebrow}</span>
          </div>
          <h2 className="font-display uppercase text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white mb-6">
            {t.inspiration.title}
          </h2>
          <p className="text-neutral-400 leading-relaxed">{t.inspiration.desc}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 lg:gap-6">
          <div className="md:col-span-7 img-hover relative group aspect-[4/5] md:aspect-auto md:h-[640px]">
            <img src={IMAGES[0].url} alt={IMAGES[0].brand} className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 right-6">
              <div className="label-eyebrow text-[#00E5FF] mb-2">{IMAGES[0].label}</div>
              <div className="font-display uppercase text-2xl text-white tracking-wider">{IMAGES[0].brand}</div>
            </div>
          </div>
          <div className="md:col-span-5 flex flex-col gap-4 lg:gap-6">
            {IMAGES.slice(1).map((img, i) => (
              <div key={i} className="img-hover relative group h-48 md:h-[202px] flex-1">
                <img src={img.url} alt={img.brand} className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="label-eyebrow text-[#00E5FF] mb-1">{img.label}</div>
                  <div className="font-display uppercase text-lg text-white tracking-wider">{img.brand}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
